import { render } from "./FriendlyGameDetails.vue?vue&type=template&id=1b38be39&scoped=true"
import script from "./FriendlyGameDetails.vue?vue&type=script&lang=js"
export * from "./FriendlyGameDetails.vue?vue&type=script&lang=js"

import "./FriendlyGameDetails.vue?vue&type=style&index=0&id=1b38be39&scoped=true&lang=css"

import exportComponent from "D:\\Projects\\diloti\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b38be39"]])

export default __exports__